import React from 'react';
import { InternalLink } from '../form-elements/Link';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Keyboard, A11y } from 'swiper';
import 'swiper/swiper-bundle.min.css';
const SubSubCategoryTiles = ({ SubSubCategories }) => {
    if (SubSubCategories && SubSubCategories.length > 0) {
        SubSubCategories = SubSubCategories.sort((a, b) => a.title.localeCompare(b.title))
    }
    SwiperCore.use([Navigation]);
    return (
        <section className="uk-section uk-section-default uk-section-small uk-padding-remove-top">
            <div className="uk-container">

                <div className="category-slider" role="region" aria-label="Subcategories">

                    {/* Navigation Buttons OUTSIDE */}
                    <button
                        type="button"
                        className="swiper-button-prev"
                        aria-label="Vorherige Kategorie"
                    />

                    <button
                        type="button"
                        className="swiper-button-next"
                        aria-label="Nächste Kategorie"
                    />

                    <Swiper
                        modules={[Navigation, Keyboard, A11y]}
                        spaceBetween={8}
                        slidesPerView="auto"
                        navigation={{
                            prevEl: '.category-slider .swiper-button-prev',
                            nextEl: '.category-slider .swiper-button-next',
                        }}
                        keyboard={{
                            enabled: true,
                            onlyInViewport: true,
                        }}
                        a11y={{
                            enabled: true,
                        }}
                        watchOverflow
                        breakpoints={{
                            0: {
                                spaceBetween: 8,
                            },
                            768: {
                                spaceBetween: 12,
                            },
                            1024: {
                                spaceBetween: 16,
                            },
                        }}
                        className="swiper-container"
                    >
                        {SubSubCategories?.map((cat, index) => (
                            <SwiperSlide
                                key={cat._id || index}
                                className="subsub-slide"
                            >
                                <InternalLink
                                    to={cat.url}
                                    modifier="primary"
                                    className="slider-link"
                                    aria-label={`Kategorie ${cat.title}`}
                                >
                                    {cat.title}
                                </InternalLink>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

            </div>
        </section>
    );
};

export default SubSubCategoryTiles;